import { useMarketWatchlists } from '../../hooks/useMarketWatchlists';
import KrHoldingsOwnership from './KrHoldingsOwnership';

export default function SystemWatchlistPanel() {
  const state = useMarketWatchlists();

  return (
    <section className="system-panel">
      <div className="system-section-head">
        <div>
          <span className="system-chip">Market Watchlist</span>
          <h2>시장별 Watchlist</h2>
        </div>
        <p>US/KR watchlist를 source 기준으로 분리해 표시합니다. LIVE는 Toss 검증 source만 후보로 봅니다.</p>
      </div>
      <div className="system-actions">
        <button
          className="system-secondary-button"
          disabled={state.loading}
          onClick={state.refreshUsLive}
        >
          Gemini→Toss US LIVE 후보 갱신
        </button>
        <button
          className="system-secondary-button"
          disabled={state.loading}
          onClick={state.refreshUsToss}
        >
          현재 US 후보 Toss 재검증
        </button>
        <button
          className="system-secondary-button"
          disabled={state.loading}
          onClick={state.importHoldings}
        >
          Toss 보유종목을 KR seed로 가져오기
        </button>
        <button
          className="system-secondary-button"
          disabled={state.loading}
          onClick={state.importKrxSeed}
        >
          KRX 대표 seed 병합
        </button>
        <button
          className="system-secondary-button"
          disabled={state.loading}
          onClick={state.refreshKrToss}
        >
          Toss KR 후보 검증
        </button>
        <button
          className="system-secondary-button"
          disabled={state.loading}
          onClick={state.refreshKrGemini}
        >
          Gemini KR 후보 생성
        </button>
      </div>
      {state.error && <div className="system-state error-state">API 오류: {state.error}</div>}
      {state.loading && !state.items.length ? (
        <div className="system-state">watchlist 조회 중...</div>
      ) : (
        <>
          <div className="watchlist-grid">
            {state.items.map((item) => <WatchlistCard key={item.market} item={item} />)}
          </div>
          <KrHoldingsOwnership items={state.krHoldings} />
        </>
      )}
    </section>
  );
}

function WatchlistCard({ item }: { item: ReturnType<typeof useMarketWatchlists>['items'][number] }) {
  const empty = item.count === 0;
  const caption = watchlistCaption(item);
  return (
    <div className={`watchlist-card ${item.market.toLowerCase()}`}>
      <div>
        <strong>{item.market}</strong>
        <span>{item.source} · {item.count}개</span>
      </div>
      <p>{empty ? '데이터 없음' : watchlistSummary(item)}</p>
      {!empty && (
        <ul className="watchlist-symbol-list">
          {displayItems(item).map((row) => (
            <li key={row.symbol}>
              <strong>{row.label}</strong>
              {row.name && <span>{row.symbol}</span>}
            </li>
          ))}
        </ul>
      )}
      <small>{caption}</small>
      {item.count > 12 && <small>외 {item.count - 12}개</small>}
    </div>
  );
}

function watchlistCaption(item: ReturnType<typeof useMarketWatchlists>['items'][number]) {
  if (item.market !== 'US') return '기존 Toss 보유주는 채택 전 자동매매 대상이 아닙니다.';
  return item.source === 'toss_us_validated'
    ? 'Gemini/기존 후보를 Toss 검증까지 통과시킨 US LIVE universe입니다.'
    : 'US paper 후보입니다. LIVE 주문 후보가 아닙니다.';
}

function displayItems(item: ReturnType<typeof useMarketWatchlists>['items'][number]) {
  const rows = item.items?.length
    ? item.items
    : item.tickers.map((symbol) => ({ symbol, name: null }));
  return rows.slice(0, 12).map((row) => ({
    symbol: row.symbol,
    name: row.name,
    label: item.market === 'KR' && row.name ? row.name : row.symbol,
  }));
}

function watchlistSummary(item: ReturnType<typeof useMarketWatchlists>['items'][number]) {
  if (item.market === 'KR') return '국내 종목은 회사명 우선, 종목코드 보조로 표시합니다.';
  return item.tickers.slice(0, 12).join(', ');
}
